module.exports = __webpack_public_path__ + "img/prioritas_bosspack_cod_dg.80c664e9.png";